import * as React from "react";
import { Link } from "react-router-dom";
import { groupAuth } from "app/utils/authGroups";

import RefundRequestsFailButton from "../../RefundRequests/RefundRequestsFailButton";

const hasAccessToFraud = groupAuth.hasAccessGroup(["Fraud/Admin"]);

type Props = {
  data: any;
  loadData: Function;
};

class Summary extends React.Component<Props> {
  render() {
    const refund = this.props.data;

    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    const formatStatus = (status) => {
      if (status === "completed") {
        return <i className="fa fa-check fa-lg" style={{ color: "green" }} />;
      } else if (status === "pending") {
        return (
          <i className="fa fa-hourglass fa-lg" style={{ color: "grey" }} />
        );
      } else if (status === "errored") {
        return <i className="fa fa-times fa-lg" style={{ color: "red" }} />;
      } else {
        return null;
      }
    };

    return (
      <section>
        <table
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
          cellPadding={0}
          cellSpacing={0}
        >
          <tbody>
            {/* Basic heading */}
            <tr>
              <td colSpan={4}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "10px",
                  }}
                >
                  <span style={{ flex: 1 }}>Basic</span>
                  {hasAccessToFraud && refund?.status === "pending" && (
                    <RefundRequestsFailButton
                      id={refund?.id}
                      reloadData={this.props.loadData}
                    />
                  )}
                </h3>
              </td>
            </tr>

            {/* Basic row 1 */}
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Date created:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                {formatDate(refund?.created_at)}{" "}
              </td>
              <td style={{ padding: "5px" }}>
                <b style={{ fontWeight: 400 }}>Date updated:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                {formatDate(refund?.updated_at)}{" "}
              </td>
            </tr>

            {/* Basic row 2 */}
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Status:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                {formatStatus(refund?.status)}{" "}
              </td>

              <td style={{ padding: "5px" }}>
                <b style={{ fontWeight: 400 }}>Amount:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {" "}
                R{(parseInt(refund?.amount, 10) / 100).toFixed(2)}{" "}
              </td>
            </tr>

            {/* Basic row 3 */}
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Original payment:</b>
              </td>
              <td style={{ padding: "5px" }}>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${refund?.original_payment?.reference}/summary`}
                >
                  {refund?.original_payment?.reference}
                </Link>
              </td>
              <td style={{ padding: "5px" }}>
                <b style={{ fontWeight: 400 }}>Refund payment:</b>
              </td>
              <td style={{ padding: "5px" }}>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${refund?.refund_payment?.reference}/summary`}
                >
                  {refund?.refund_payment?.reference ?? "-"}
                </Link>
              </td>
            </tr>

            {/* Basic row 4 */}
            <tr>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Comments:</b>
              </td>
              <td style={{ padding: "5px" }}> {refund?.comments} </td>
            </tr>
          </tbody>
        </table>
      </section>
    );
  }
}

export default Summary;
